export default "__VITE_ASSET__3bf0c693__"